import { NavLink } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { hasCapability } from "@/lib/roles";

const items = [
  ["/app/fees/overview", "Overview", ["super_admin", "director", "accountant", "receptionist"]],
  ["/app/fees/structures", "Fee Structures", ["super_admin", "director"]],
  ["/app/fees/accounts", "Student Accounts", ["super_admin", "director", "accountant", "receptionist"]],
  ["/app/fees", "Payments", ["super_admin", "director", "accountant", "receptionist"]],
  ["/app/fees/catalogue", "Products & Services", ["super_admin", "director", "accountant", "inventory_officer"]],
  ["/app/fees/class-summary", "Payment Status", [], "finance.payment_status.view_class"],
  ["/app/fees/estimates", "Estimates & Invoices", ["super_admin", "director", "accountant", "receptionist"]],
  ["/app/fees/scholarships", "Scholarships", ["super_admin", "director"]],
  ["/app/fees/operations", "Refunds / Reversals", ["super_admin", "director", "accountant", "receptionist"]],
  ["/app/fees/reconciliation", "Reconciliation", ["super_admin", "director", "accountant"]],
];

const FinanceNav = () => {
  const { user } = useAuth();
  const roles = new Set(user?.roles || (user?.role ? [user.role] : []));
  return <nav className="flex gap-1 overflow-x-auto border-b border-[#E2E8F0] mb-6 pb-1" aria-label="Finance">
    {items.filter(([, , allowed, capability]) => capability ? hasCapability(user, capability) : allowed.some((role) => roles.has(role))).map(([to, label]) => <NavLink key={to} to={to} end={to === "/app/fees"} className={({ isActive }) => `shrink-0 px-3 py-2 rounded-t-lg text-sm ${isActive ? "bg-[#1B2C5A] text-white" : "text-[#475569] hover:bg-[#9DCD3F]/10"}`}>{label}</NavLink>)}
  </nav>;
};
export default FinanceNav;
